
<script>
    import FramedImageAppearanceMixin from "../../../author/pagesbuilder/mixins/FramedImageAppearanceMixin";

    export default {
        name: "FramedImageElement",
        mixins: [
            FramedImageAppearanceMixin
        ],
        data() {
            return {
                elementType: 'framed-image',
            }
        },
        computed: {
            getDefaultDataStructure () {
                return {
                    elementType: this.elementType,
                    elementId: this.elementId,
                    styles: null,
                    linkData: {},
                    responsiveFrameSizeClass: {
                        'desktop': '',
                        'tablet-portrait': '',
                        'tablet-landscape': '',
                        'smartphone-portrait': '',
                        'smartphone-landscape': ''
                    },
                    responsiveFrameShapeClass: {
                        'desktop': '',
                        'tablet-portrait': '',
                        'tablet-landscape': '',
                        'smartphone-portrait': '',
                        'smartphone-landscape': ''
                    },
                    itemVisibilitySettings: null
                }
            },
        }
    }
</script>

